export default "import { VuiStat } from \"../../../lib\";\n\nexport const Stat = () => {\n  return <VuiStat title=\"Latency\" text=\"67ms\" />;\n};\n";